import * as React from 'react';
import * as styles from './ScrollableContentWrapper.css';

export const ScrollableContentWrapper: React.FC = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
